import CompanyProductPickPage from "./page";
import CompanyProductPickTemplate from "./template";

export {
  CompanyProductPickTemplate
};

export default CompanyProductPickPage;
